import React from 'react';

export default function RecursosPage() {
  return (
    <div>
      Qualidade - Recursos (placeholder).
    </div>
  );
}

